import axios from '@/axios';

export async function getReasonNotValidations(params) {
    const { data } = await axios.get("option_not_to_donates/filter", { params });
    return data.data ? data.data : data;
}

export async function saveReasonNotValidation(id, data) {
    const method = id ? 'PUT' : 'POST';
    const url = id ? `/option_not_to_donates/${id}` : `option_not_to_donates/create`;
    return await axios({ method, url, data: data  });
}
